import { render, staticRenderFns } from "./grossing-touch-sample-tab-data.vue?vue&type=template&id=06cde26c&scoped=true&"
import script from "./grossing-touch-sample-tab-data.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-sample-tab-data.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-sample-tab-data.scss?vue&type=style&index=0&id=06cde26c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cde26c",
  null
  
)

export default component.exports